import type { DocumentStructureItem, Tables } from "@msuite/utils/types";
import { useMemo } from "react";
import { FileIcon } from "../../file-upload";
import type { Disclosure } from "../../hooks";
import { Icon } from "../../icons";

export function useFileExplorerIcon<T extends { file: Tables<"files"> }>(
	item: DocumentStructureItem<T>,
	disclosure?: Disclosure,
) {
	const icon = useMemo(() => {
		const isFolder = item.type === "folder";
		if (isFolder) {
			return (
				<Icon
					name={!disclosure?.isOpen ? "Folder" : "FolderOpen"}
					className="stroke-accent-500"
				/>
			);
		} else {
			return (
				<FileIcon
					fileType={item.file.contentType}
					fileName={item.file.fileName}
					size={12}
				/>
			);
		}
	}, [item.type, disclosure]);

	return icon;
}
